/**
 * Detect a real Supabase auth redirect (PKCE ?code=, error, or #access_token hash).
 * Do not treat marketing hashes (#demo) or leftover invite tokens as callbacks.
 */
export function hasSupabaseAuthCallbackParams(search?: string, hash?: string): boolean {
  const query = new URLSearchParams(
    search ?? (typeof window !== "undefined" ? window.location.search : "")
  );
  if (query.get("code") || query.get("error") || query.get("error_description")) return true;

  const rawHash = hash ?? (typeof window !== "undefined" ? window.location.hash : "");
  if (!rawHash || rawHash.length < 2) return false;
  const hashParams = new URLSearchParams(rawHash.startsWith("#") ? rawHash.slice(1) : rawHash);
  return !!(
    hashParams.get("access_token") ||
    hashParams.get("refresh_token") ||
    hashParams.get("type") ||
    hashParams.get("error")
  );
}
